class FormDisabled {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    var agreementCheckbox = document.getElementById('agreement-1');

    function handleCheckboxChange() {
        var mainForm = document.querySelector('.s-form__main');

        if (agreementCheckbox.checked) {
            mainForm.classList.remove('disabled');
        } else {
            mainForm.classList.add('disabled');
        }
    }
    agreementCheckbox.addEventListener('change', handleCheckboxChange);
    handleCheckboxChange();

    // 空のpタグを削除
    var paragraphs = document.querySelectorAll('p');
    paragraphs.forEach(function (paragraph) {
      if (paragraph.textContent.trim() === '') {
          paragraph.remove();
      }
    });
  }
}
